module.exports = __webpack_public_path__ + "static/media/warningIcon.41822a76.svg";